import { TableCell, tableCellClasses } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { CLOUDN_COLORS, COLORS } from "../../constants/colors";
import { PublicStyledTableCellProps } from "../../constants/types";

const StyledTableCell = styled(TableCell)<any>(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: "1em",
    fontWeight: 500,
    color: "white",
    backgroundColor: CLOUDN_COLORS.logoSkyBlue,
    border: `0.08vw solid white`,
    borderBottom: "none",
    top: -1,
    zIndex: 2,
    // cursor: "pointer",
  },
  [`&.${tableCellClasses.head}:last-child`]: {
    // borderRight: "none",
  },
  // [`&.${tableCellClasses.head}:hover`]: {
  //   backgroundColor: CLOUDN_COLORS.skyBlue,
  // },
  [`&.${tableCellClasses.body}`]: {
    padding: "0.65%",
    fontSize: "1em",
    fontWeight: 600,
    color: COLORS.fontColor,
  },
}));
const PublicStyledTableCell = (props: PublicStyledTableCellProps) => {
  const fhd = useMediaQuery({ maxDeviceWidth: 2000 });
  const qhd = useMediaQuery({ maxDeviceWidth: 2600 });

  return (
    <StyledTableCell
      align={"center"}
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      style={{
        width: props.width + "%",
        top: props.top,
        borderTop: props.borderTop ? null : "none",
        borderLeft: props.borderTop ? "none" : null,
        borderRight: props.borderTop ? "none" : null,
        padding: fhd ? "0.5%" : qhd ? "0.6%" : "0.8%",
      }}
    >
      {props.children}
    </StyledTableCell>
  );
};

export default PublicStyledTableCell;
